import { giphyYellow } from '@giphy/colors'
import { fontFamily } from 'utils'
import { TextStyle } from '../../types'

export const MAX_PREVIEW_HEIGHT = 450
export const MAX_PREVIEW_WIDTH = 750

// captions
export const DEFAULT_CAPTION_STYLE: TextStyle = {
    align: 'center',
    color: giphyYellow,
    fontFamily: fontFamily('subtitle'),
    fontSize: 30,
    fontWeight: 'normal',
}
